import { ReactElement } from 'react';

enum STEPS {
  STUDENT_DATA= 0,
  SIMULATION = 1,
  ACADEMIC_HISTORY= 2,
  TARGET_SELECTION= 3,
  DOCUMENT_UPLOAD = 4,
  FINISH= 5

}

export type StepList = {
  key: STEPS
  title: string
  component: ReactElement,
  completed?:boolean
}
export default STEPS;
